// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type MoneyBackGuarantee24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const MoneyBackGuarantee24: FC<MoneyBackGuarantee24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M4 8h16V6H4v2ZM2 6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v6H4v6h4.1v2H4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6Zm12.95 16-4.25-4.25 1.4-1.4 2.85 2.8 5.65-5.65 1.4 1.45L14.95 22ZM4 6v12-4.5 2.825V6Z" />
        </svg>
    );
};

export default MoneyBackGuarantee24;
